<div class="row">
  <div class="col-md-6 offset-3">
    <h3>Erreur 404</h3>
    <p>La page recherchée n'existe pas !</p>
  </div>
</div>
